// This file is auto-generated. Edit data.graphql to change it.
import { DataProvider , useSetFlowToBasedOnData } from 'Simple/Data'
import { useSubscription } from 'Data/Api'
import useDataConfiguration from './useDataConfiguration'
import query from './data.graphql.js'
import React from 'react'
import View from './view'

/** @type {import('Simple/types.js').Data} */
export default function ContentData(props) {
  let configuration = useDataConfiguration(props)
  let [{ data: rdata, error }, reExecuteQuery] = useSubscription({ query, ...configuration })
  let data = rdata?.comms_threads

      useSetFlowToBasedOnData({
        data,
        fetching: typeof data === 'undefined',
        error,
        pause: configuration.pause,
        viewPath: props.viewPath,
      })
      

  return (
    <DataProvider
      context="thread_alerts"
      value={data}
      viewPath={props.viewPath}
    >
      <View {...props} />
    </DataProvider>
  )
}